import { getLoginActivityApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment';
import { AdminPage, RangeBar, rangeLabelOf } from './AdminAnalyticsUI';
import TimeframeHeader from './TimeframeHeader';
import AnalyticLoginCard from './AnalyticLoginCard';
import ActiveUserInLoginActivity from './ActiveUserInLoginActivity';

function UserLoginActivity({setActivePanel, activePanel}) {
    const {makeApiCallFunc} = useContext(Context);
    const [loginData, setLoginData] = useState(false);
    const [frame, setFrame] = useState("today");

    const [xAxisValues, setXAxisValues] = useState([]);
    const [values, setValues] = useState([]);
    const [totalCount, setTotalCount] = useState();

    const [loadUserActivity, setLoadUserActivity] = useState(true);

    const [dateRange, setDateRange] = useState([
        {
          startDate: new Date(Date.now()),
          endDate: new Date(Date.now()),
          key: 'selection'
        }
      ]);
      const isMoreThanNDays = (days) => {
        const date1 = moment(dateRange[0]?.startDate);
        const date2 = moment( dateRange[0]?.endDate);
        const differenceInDays = date2.diff(date1, 'days');
    
        // Check if the difference is more than 60 days
        const moreThanNDaysApart = differenceInDays > days;
        return moreThanNDaysApart;
      }
    useEffect(() => {
        makeApiCallFunc(getLoginActivityApi,
                {
                    startTime : dateRange?.[0]?.startDate,
                    endTime : dateRange?.[0]?.endDate
                },
            ({data})=> {
              setLoginData(data);
              getCountTotal(data);
            },
            (data) => console.log(data) 
            )
    },[loadUserActivity]);
    const getCountTotal = (data) => {
      const dates = [];
      let values = {
        "professional" : [],
        "client" : []
      };
      let currentDate = moment(dateRange[0]?.startDate);
      const finalDate = moment(dateRange[0]?.endDate);
      const count = {
        "professional": 0,
        "client" : 0,
      }
      if(isMoreThanNDays(365))
      {
          while (currentDate <= finalDate){
            dates.push(moment(currentDate).format("YYYY"));
            const addedValues = addUpValues(moment(currentDate).startOf("year"), moment(currentDate).add(1, "year").startOf("year"), data);
            values.professional.push(addedValues?.professional);
            values.client.push(addedValues?.client);
            currentDate = moment(currentDate).add(1, "year");
          }
          values.professional.map((i) =>  count.professional = count.professional + i);
          values.client.map((i) =>  count.client = count.client + i);
      }
      else if(isMoreThanNDays(30))
      {
          while (currentDate <= finalDate){
            dates.push(moment(currentDate).format("MMM YYYY"));
            const addedValues = addUpValues(moment(currentDate).startOf('month'), moment(currentDate).add(1, "month").startOf('month'), data);
            values.professional.push(addedValues?.professional);
            values.client.push(addedValues?.client);
            currentDate = moment(currentDate).add(1, "month");
          }
          values.professional.map((i) =>  count.professional = count.professional + i);
          values.client.map((i) =>  count.client = count.client + i);
      }
      
      else
      {
        while (currentDate <= finalDate) {
          dates.push(moment(currentDate).format("MM-DD-YYYY"));
          const valueseOnGivenDate = getValues(currentDate, data);
          values.professional.push(valueseOnGivenDate?.totalProfLoginCount);
          values.client.push(valueseOnGivenDate?.totalClientLoginCount);
          count.professional = count.professional + valueseOnGivenDate?.totalProfLoginCount;
          count.client = count.client + valueseOnGivenDate?.totalClientLoginCount;
          currentDate = moment(currentDate).add(1, "days");
        }
      }
      
      setXAxisValues(dates);
      setValues(values);
      setTotalCount(count);
      return dates;
    }
    const addUpValues = (startD, endD, data) => 
    {
      const returnObj = {
        professional: 0,
        client: 0
      }
      while (startD < endD) {
        const valueseOnGivenDate = getValues(startD, data);
        returnObj.professional = returnObj.professional + valueseOnGivenDate?.totalProfLoginCount;
        returnObj.client = returnObj.client + valueseOnGivenDate?.totalClientLoginCount;
        startD = moment(startD).add(1, "days");
      }
      return returnObj;
    }
    const getValues = (currentDate, data) => {
      var itemToRe = {
        totalProfLoginCount: 0,
        totalClientLoginCount: 0
      };
      const date2 = moment(currentDate);
      console.log(data)
      data?.map((item) => {
      const date1 = moment(item?.created_at);
      
      const areDatesSame = date1.isSame(date2, "day"); // Change "day" to "date" if you want to compare the dates down to the millisecond
      if(areDatesSame)
      { 
        itemToRe = item;
      }
    })
    return itemToRe;
  
  }
    const isSingleDay = () => {
      const date1 = moment(dateRange[0]?.startDate);
      const date2 = moment( dateRange[0]?.endDate);
  
      // Compare if the two dates are the same
      const areDatesSame = date1.isSame(date2, "date"); // Change "day" to "date" if you want to compare the dates down to the millisecond
      return areDatesSame
    }
  return (
    <AdminPage setActivePanel={setActivePanel} activePanel={activePanel} title="Active logins" subtitle="Successful sign-ins by professionals and clients.">
      <RangeBar dateRange={dateRange}>
        <TimeframeHeader className='flex items-center' setLoadCaseAnalytics={setLoadUserActivity} frame={frame} setFrame={setFrame} setDateRange={setDateRange} dateRange={dateRange}/>
      </RangeBar>
      <AnalyticLoginCard
        totalCount={totalCount}
        xAxisValues={xAxisValues}
        values={values}
        rangeLabel={rangeLabelOf(dateRange)}
      />
      <div style={{ marginTop: '28px' }}>
        <ActiveUserInLoginActivity userData={loginData} date={dateRange}/>
      </div>
    </AdminPage>
  )
}

export default UserLoginActivity